import React, { useState, useEffect } from "react";
import tick from "../assests/images/tick.svg";
import cross from "../assests/images/error.svg";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import { Col, Container, Row } from "react-bootstrap";
import axios from "../api/axios";
import LoadingGif from "../assests/images/loading.gif";

export default function TokenStatus() {
  const { isDesktopLogin } = useResponsiveFlags();
  const [loading, setLoading] = useState(true);
  const [tokenData, setTokenData] = useState(null);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    axios
      .get("/api/get-all-tokens")
      .then((res) => {
        setTokenData(res.data.items);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch token data.");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getTokenType = (token) => {
    if (token === "trial" || token === "hires-trial") {
      return "Free Trial Token";
    }
    if (token === "full" || token === "hires-full") {
      return "Per Sample Token";
    }
    if (token === "seat" || token === "hires-seat") {
      return "Annual Per-Seat Token";
    }
    return "Unknown Type";
  };
  const checkValidStatus = (token) => {
    let valid = true;
    if (!token.valid) {
      valid = false;
    }
    if (new Date(token.expire).getTime() < Date.now()) {
      valid = false;
    }
    if (token.type === "trial" || token.type === "hires-trial" || token.type === "full" || token.type === "hires-full") {
      if (token.sampleremain <= 0) {
        valid = false;
      }
    }
    return valid;
  }
  return (
    <>
      <p className="custom-title">Token Status</p>
      <div className="my-4">
        {loading || error ? (
          <div className="text-center" style={{ height: "98px" }}>
            {loading && <img src={LoadingGif} alt="loading..." height="100%" />}
            {error && <span className="error-text">{error}</span>}
          </div>
        ) : (
          <>
            {tokenData?.length > 0 ? (
              <>
                {tokenData.map((token) => (
                  <div
                    key={token.id}
                    className="card mb-3 w-100"
                    style={{
                      border: "none",
                      boxShadow: "2px 2px 14px rgba(0, 0, 0, 0.1)",
                      borderRadius: "20px",
                    }}
                  >
                    <div className="card-body">
                      <div
                        className={`table-responsive token-status-card ${isDesktopLogin ? "d-block" : "d-none"
                          }`}
                      >
                        <table
                          className="table table-borderless"
                          style={{ marginBottom: "0" }}
                        >
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                className="storage-limit"
                                style={{ width: "20%", minWidth: "330px" }}
                              >
                                Token ID
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "10%", minWidth: "84px" }}
                              >
                                Module
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "10%", minWidth: "106px" }}
                              >
                                Type
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "8%" }}
                              >
                                Total
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "10%" }}
                              >
                                Remaining
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "8%" }}
                              >
                                Pending
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "10%", minWidth: "103px" }}
                              >
                                Expires
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "10%", minWidth: "103px" }}
                              >
                                Last Used
                              </th>
                              <th
                                className="storage-limit"
                                style={{ width: "10%", minWidth: "103px" }}
                              >
                                Created
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <img
                                  src={checkValidStatus(token) ? tick : cross}
                                  alt="status"
                                />
                              </td>
                              <td>{token.token}</td>
                              <td>
                                {token.type === "full" ||
                                  token.type === "trial" ||
                                  token.type === "seat"
                                  ? "iSort™ Fractions"
                                  : "iSort™ Hires"}
                              </td>
                              <td>{getTokenType(token.type)}</td>
                              <td>{token.sampletotal}</td>
                              <td>{token.sampleremain}</td>
                              <td>{token.samplepend}</td>
                              <td>{token.expire}</td>
                              <td>{token.lastused}</td>
                              <td>{token.created}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        className={`${!isDesktopLogin ? "d-block" : "d-none "
                          } pt-2 px-3 `}
                      >
                        <p className="mb-1 storage-limit">Token ID</p>
                        <div
                          className="d-flex align-items-center"
                          style={{ marginBottom: "13px" }}
                        >
                          <img
                            src={checkValidStatus(token) ? tick : cross}
                            alt="status"
                            className="me-2"
                          />
                          <span className="text-break">{token.token}</span>
                        </div>
                        <Container fluid style={{ padding: "0" }}>
                          <Row>
                            <Col className="d-flex justify-content-start">
                              <div style={{ maxWidth: "167px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Type</p>
                                <p>{getTokenType(token.type)}</p>
                              </div>
                            </Col>
                            <Col className="d-flex justify-content-center">
                              <div
                                style={{ maxWidth: "155px", width: "100%" }}
                              ></div>
                            </Col>
                            <Col className="d-flex justify-content-end">
                              <div style={{ maxWidth: "155px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Module</p>
                                <p>
                                  {token.type === "full" ||
                                    token.type === "trial" ||
                                    token.type === "seat"
                                    ? "iSort™ Fractions"
                                    : "iSort™ Hires"}
                                </p>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex justify-content-start">
                              <div style={{ maxWidth: "167px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Total</p>
                                <p>{token.sampletotal}</p>
                              </div>
                            </Col>
                            <Col className="d-flex justify-content-center">
                              <div style={{ maxWidth: "155px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Remaining</p>
                                <p>{token.sampleremain}</p>
                              </div>
                            </Col>
                            <Col className="d-flex justify-content-end">
                              <div style={{ maxWidth: "155px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Pending</p>
                                <p>{token.samplepend}</p>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex justify-content-start">
                              <div style={{ maxWidth: "167px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Expires</p>
                                <p>{token.expire}</p>
                              </div>
                            </Col>
                            <Col className="d-flex justify-content-center">
                              <div style={{ maxWidth: "155px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Last Use</p>
                                <p>{token.lastused}</p>
                              </div>
                            </Col>
                            <Col className="d-flex justify-content-end">
                              <div style={{ maxWidth: "155px", width: "100%" }}>
                                <p className="mb-1 storage-limit">Created</p>
                                <p>{token.created}</p>
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="text-center" style={{ height: "98px" }}>
                <span className="error-text">No Token Found</span>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
